import Model, { attr } from '@ember-data/model';

export default class UserFundSettingModel extends Model {
  @attr('string') settingType!: UserFundSettingType;
  @attr() vals!: UserFundSettingValsPinnedCampaignIds;
}

export type UserFundSettingType = 'pinned_campaigns';

export interface UserFundSettingValsPinnedCampaignIds {
  campaign_ids: string[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'user-fund-setting': UserFundSettingModel;
  }
}
